module.exports = "<div class=\"ctx-navigation-bar\">\n    <div class=\"nav-bar-left\" ng-transclude=\"leftSlot\"></div>\n    <div class=\"nav-bar-right\" ng-transclude=\"rightSlot\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxNavigationBar/ctxNavigationBar.template.html
// module id = 158
// module chunks = 0 1